import React from 'react';
import Breadcrumb from 'components/Breadcrumb';
import DataPeriodSelect from 'components/DataPeriodSelect';
import '../styles.scss';

interface Props {
  weeks: number;
  onWeekScopeSelect: any;
}

const PortfolioPageHeader: React.FC<Props> = ({ onWeekScopeSelect, weeks }) => (
  <div className="page-header">
    <Breadcrumb />
    <div className="buttons">
      <DataPeriodSelect currentWeeks={weeks} onSelect={onWeekScopeSelect} />
    </div>
  </div>
);

export default PortfolioPageHeader;
